import type { CfAssetDrag } from '@repo/studio-components-asset-drag/asset'
import type { ChatMessage } from '../types'

type AidaMedia = NonNullable<ChatMessage['media']>

export function cfAssetFromMedia(media: AidaMedia): CfAssetDrag | null {
  if (media.status !== 'ready' || !media.url || !media.generationId) {
    return null
  }
  const width = positiveSize(media.width)
  const height = positiveSize(media.height)
  const previewUrl = media.posterUrl || media.thumbnailUrl || undefined
  return {
    mediaType: media.kind,
    url: media.url,
    toolName: 'aida',
    id: media.generationId,
    ...(width ? { width } : {}),
    ...(height ? { height } : {}),
    ...(previewUrl ? { previewUrl } : {}),
  }
}

export function promptRefForAsset(
  asset: CfAssetDrag,
  messages: readonly Pick<ChatMessage, 'media'>[],
): string | null {
  for (const message of messages) {
    const media = message.media
    if (media?.generationId === asset.id && media.promptRef) {
      return media.promptRef
    }
  }
  return null
}

function positiveSize(value: number | undefined) {
  if (typeof value !== 'number' || !Number.isFinite(value) || value <= 0) {
    return undefined
  }
  return value
}
